// extracted by mini-css-extract-plugin
export default {"wrapper__loading":"Common_wrapper__loading__cmQ4U","no_service":"Common_no_service__ktGBF"};